import React, { useContext, useEffect, useState } from "react";
import {
  ListItem,
  makeStyles,
  List,
  ListItemText,
  ListItemIcon,
} from "@material-ui/core";
import { Form, Formik } from "formik";
import NewCaseField from "../shared/NewCaseField";
import { Button } from "@material-ui/core";
import { Endpoint } from "../../api/base";
import { AccountContext } from "../Accounts";
import { useToast } from "../../context/ToastContext";
import { object, string, number, array } from "yup";
import UpdateProfileValidation from "../UpdateProfileValidation";
import { getUser, getUserProfileTokenName } from "../shared/helpers/helper";
import UpdateProfile from "./UpdateProfile";
import UpdatePassword from "./UpdatePassword";
import { tokens } from "../../theme/tokens";
const useStyles = makeStyles(({ theme }) => ({
  topBar: {
    height: "50px",

    padding: "0 2% 0 2%",
    display: "flex",
    alignItems: "center",
  },
  heading: {
    fontSize: "1em",
    color: "#555555",
    fontWeight: 500,
  },
  passwordContainer: {
    display: "flex",
    flexDirection: "column",
    width: "90%",
  },
  caseContainer: {
    // width: "928px",
    width: "98%",
    paddingLeft: "2%",
  },
  parent: {
    justifyContent: "space-between",
    flexDirection: "row",
    flexWrap: "wrap",
    display: "flex",
    paddingRight: "2%",
    marginTop: "2vh",
  },
  parentChild: {
    flex: "1",
    width: "40%",
    "&:nth-child(1)": {
      paddingRight: "5vh",
    },
    "&:nth-child(2)": {
      paddingLeft: "5vh",
    },
  },
  rowContainer: {
    display: "flex",
    marginTop: "8px",
  },
  labelContainer: {
    display: "flex",
    width: "50%",
    alignItems: "center",
    "& p": {
      fontSize: "1em",
      // fontWeight:"bold",
      color: "black",
    },
  },
  fieldContainer: {
    width: "50%",
  },
  postButton: {
    height: "35px",
    fontSize: ".9em",
    marginTop: "20px",
    width: "160px",
    color: "white",
    backgroundColor: tokens.color.brand.primaryAction,
    //fontWeight: "bold",
    textTransform: "capitalize",
    // border: "1px solid #3C72D9",
    borderRadius: "25px",
    "&:hover": {
      backgroundColor: tokens.color.brand.primaryAction,
      opacity: "0.8",
    },
    "&.Mui-disabled": {
      backgroundColor: "#e7e7e7",
      color: "white",
    },
  },
}));

function UpdateProfileDialog({ setProfileDialogClose }) {
  const classes = useStyles();
  const userInfo = getUser();
  const [state, setState] = useState("profile");
  const [initValue, setInitValue] = useState({
    profile: {
      user_name: userInfo.user_name,

      user_details: {
        given_name: userInfo.given_name === "empty" ? "" : userInfo.given_name,
        family_name:
          userInfo.first_name === "empty" ? "" : userInfo.family_name,
        address: userInfo.address === "empty" ? "" : userInfo.address,
        address2: "",
        email: userInfo.email,
        "custom:Admin": !userInfo["custom:Admin"]
          ? ""
          : userInfo["custom:Admin"],
        "custom:PINo": !userInfo["custom:Pi_no"]
          ? ""
          : userInfo["custom:Pi_no"],
      },
    },
    password: {
      old_password: "",
      new_password: "",
      new_password_confirmation: "",
    },
  });
  const { showToast } = useToast();
  const { getSession, changePassword } = useContext(AccountContext);

  const getCognitoErrorMessage = (err) => {
    const code = err?.code || err?.name;
    if (code === "NotAuthorizedException")
      return "Incorrect current password, or your session has expired. Please log out and back in if the problem persists";
    if (code === "InvalidPasswordException")
      return "New password must include uppercase, lowercase, a number, and a symbol";
    if (code === "LimitExceededException")
      return "Too many attempts. Please wait a moment and try again";
    return "Sorry something went wrong, please try again later";
  };
  const handleStateChange = () => {
    if (state === "password") setState("profile");
    else setState("password");
  };
  const handleSubmit = (e) => {
    console.log(e);
    if (state !== "password") {
      var obj = {
        user_name: e.user_name,

        user_details: {
          given_name:
            e.user_details.given_name === ""
              ? "empty"
              : e.user_details.given_name,
          family_name:
            e.user_details.family_name === ""
              ? "empty"
              : e.user_details.family_name,
          address:
            e.user_details.address === ""
              ? "empty"
              : `${e.user_details.address} ${e.user_details.address2}`,
          email: e.user_details.email,
          "custom:Admin": e.user_details["custom:Admin"],
          "custom:Pi_no": e.user_details["custom:PINo"],
        },
      };
      Endpoint.updateProfile(obj)
        .then((res) => {
          console.log(res);
          showToast("Profile updated successfully", "success");
          getSession();
          setProfileDialogClose();
          // window.location.reload()
        })
        .catch((err) => {
          console.log(err);
          showToast("Sorry something went wrong, please try again later", "error");
        });
    } else {
      changePassword(e.old_password, e.new_password)
        .then((res) => {
          showToast("Password change successfully", "success");
          setState("profile");
        })
        .catch((err) => {
          console.error(err);
          showToast(getCognitoErrorMessage(err), "error");
        });
    }
  };
  return (
    <div>
      <div className={classes.topBar}>
        <span className={classes.heading}>
          {state === "password"
            ? "Update password"
            : "Add or update profile information"}
        </span>
      </div>

      <div className={classes.caseContainer}>
        <Formik
          enableReinitialize={true}
          validationSchema={UpdateProfileValidation[state]}
          validateOnBlur={false}
          validateOnChange
          initialValues={initValue[state]}
          onSubmit={(e) => {
            handleSubmit(e);
          }}
          render={({
            isSubmitting,
            dirty,
            touched,
            values,
            errors,
            isValid,
            setFieldValue,
          }) => (
            <Form>
              {state === "password" ? (
                <UpdatePassword classes={classes} />
              ) : (
                <UpdateProfile classes={classes} />
              )}

              <Button
                className={classes.postButton}
                type={"submit"}
                disabled={!isValid}
                style={{
                  marginTop: "80px",
                  float: "right",
                  marginRight: "7vh",
                }}
              >
                Update
              </Button>
              {state !== "password" ? (
                <Button
                  className={classes.postButton}
                  onClick={handleStateChange}
                  style={{
                    width: "185px",
                    marginTop: "80px",
                    float: "right",
                    marginRight: "7vh",
                  }}
                >
                  Change Password
                </Button>
              ) : null}
            </Form>
          )}
        />
      </div>
    </div>
  );
}

export default UpdateProfileDialog;
